import { HttpClient } from '@angular/common/http';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { BiosampleSearchColumnFields, BiosampleSearchGridOptionsFormatter } from '@app/search/gridOptions/biosample-search-grid-options-formatter';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';
import { BiosampleLinkRendererBaseParams, BiosampleLinkRendererComponent } from '@app/shared/cell-renderers/biosample-link-renderer/biosample-link-renderer.component';


export class BiosampleLaunchFormChooserGridOptionsFormatter extends BiosampleSearchGridOptionsFormatter {
  constructor(
      public resourceDictionaryService: SearchResourceDictionaryService,
      public bsshDatePipe: BsshDatePipe,
      public http: HttpClient
  ) {
      super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<BiosampleSearchColumnFields> {
      const inclusiveColumns: BiosampleSearchColumnFields[] = [
          BiosampleSearchColumnFields.Name,
          BiosampleSearchColumnFields.LibraryPrepKit,
          BiosampleSearchColumnFields.DefaultProjectName,
          BiosampleSearchColumnFields.Updated,
          BiosampleSearchColumnFields.Created,
          BiosampleSearchColumnFields.Owner,
          BiosampleSearchColumnFields.LabStatus,
          BiosampleSearchColumnFields.Status
        ];

      const overrideColumnDefinitions: OverrideColumnDefinition<BiosampleSearchColumnFields>[] = [
        {
          colId: BiosampleSearchColumnFields.Name,
          cellRendererFramework: BiosampleLinkRendererComponent,
          showAlways: true,
          cellRendererParams: (params) => {
            const resource: any = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType); 
              if(params.data) {
                return {
                  linkText: resource.Name,
                  linkUrl: BsApiEndPoints.getBiosampleDetailsRoute(resource.Id),
                  biosampleId: resource.Id,
                  // Returns null when the row is selectable, which leaves the tooltip off.
                  tooltipText: this.getUnselectableRowMessage(params.node)
                } as BiosampleLinkRendererBaseParams;
            } else {
                return {};
            }
          
        }
      }, 
      {
        colId: BiosampleSearchColumnFields.LibraryPrepKit,
        showAlways: true
      }
    ];

      return {
          inclusiveColumns,
          overrideColumnDefinitions
      };
  }
}

